/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import { Button } from 'antd'
import Actions from '../../../actions'
import Dialog from '../../common/Dialog'
import dayjs from 'dayjs'
import $t from '../../../i18n'
import { useRouteMatch } from 'react-router'
import FilePreviewPage from '../FilePreviewPage'
import { referralClinicTypes, routes } from '../../../consts'
import SelectedLabFacility from '../SelectedLabFacility'
import config from '../../../config.json'
import { uriEncodeSearchParams } from '../../../utils/encodingUtils'
import Page from '../../common/Page'
import ListView from '../../common/ListView'

import './Referrals.css'
import { getIsHmoMember } from '../../../utils/hmoUtils'

const Referrals = () => {
  const dispatch = useDispatch()
  const { path, url } = useRouteMatch()
  const [shouldShowReferralDialog, setShouldShowReferralDialog] = useState({
    openModal: false,
    id: null,
    fileId: null
  })
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const userDetails = useSelector(state => state?.profile?.userDetails)
  const referrals = useSelector(state => state.medicalInfo?.currentReferrals)
  const isLoading = useSelector(state => state.medicalInfo?.isLoadingDocs)
  const isQuestReferralLoading = useSelector(
    state => state.medicalInfo?.questReferralRecieveLoader
  )
  const questReferrals = useSelector(
    state => state.medicalInfo?.currentQuestReferrals
  )
  const isReferralsLoading = useSelector(
    state => state.medicalInfo?.isReferralsLoading
  )

  const [referralList, setReferralList] = useState([])

  useEffect(() => {
    if (!isQuestReferralLoading && referrals) {
      dispatch(
        Actions.createAction(Actions.SET_REFERRALS_BY_ID, {
          id: selectedMemberId
        })
      )
    }
  }, [selectedMemberId, isQuestReferralLoading])

  const onClickGetReferral = r => {
    const fileId = r?.generic_referral_id || r?.pdf
    if (r?.is_generic_referral) {
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, `${url}/${fileId}`))
    } else {
      if (r?.order_id) {
        setShouldShowReferralDialog({
          openModal: true,
          id: r?.order_id,
          fileId
        })
      }
    }
  }

  const onClickLabFacility = ({ locationId, orderId }) => {
    const link = uriEncodeSearchParams('', {
      location: locationId,
      order: orderId
    })
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        `${routes.SELECTED_LAB_FACILITY}/${link}`
      )
    )
  }

  const titleByReferralAndMemberType = isGenericReferral => {
    if (getIsHmoMember(userDetails)) {
      return isGenericReferral
        ? $t('referrals.viewNonQuestReferralTitle')
        : $t('referrals.nonQuestReferralTitle')
    } else {
      return isGenericReferral
        ? $t('referrals.viewReferralTitle')
        : $t('referrals.genericReferralTitle')
    }
  }
  const getQuestReferralsActions = r => [
    {
      title: $t('referrals.labFacility'),
      onClick: e => {
        onClickLabFacility({
          locationId: r?.location_id,
          orderId: r?.order_id
        })
        e.stopPropagation()
      }
    },
    {
      title: titleByReferralAndMemberType(r?.is_generic_referral),
      onClick: e => {
        onClickGetReferral(r)
        e.stopPropagation()
      }
    }
  ]

  useEffect(() => {
    let combinedReferrals = [...questReferrals]

    if (referrals?.length) {
      const gatherSameIds = questReferrals.map(item => item.generic_referral_id)
      const removeDuplicateGenericReferral = referrals.filter(
        item => !gatherSameIds.includes(item.file)
      )

      combinedReferrals = [
        ...combinedReferrals,
        ...removeDuplicateGenericReferral
      ]
    }

    const data = combinedReferrals?.map(r => {
      const fileId = r?.generic_referral_id || r?.file || 0
      const pdfLink = r.lab_referral_pdf
      return {
        issueDate: r?.isQuestReferral
          ? dayjs(r?.tests_ordered_date).format(config.questDateFormat)
          : dayjs(r?.creationDate).format(config.questDateFormat),
        title: r?.isQuestReferral ? $t('questReferrals.labQuest') : r?.type,
        genericTitle: $t('questReferrals.genericReferral'),
        isPressable: !!r?.generic_referral_id || !!r?.file,
        tests: r?.tests_ordered,
        patientId: r?.patient,
        onClick: pdfLink
          ? () => {
              const link = uriEncodeSearchParams('', {
                shouldShowPdfByUrl: !!pdfLink
              })
              dispatch(
                Actions.createAction(Actions.VIEW_DOCUMENT_BY_URL, {
                  pdf: pdfLink
                })
              )
              dispatch(
                Actions.createAction(
                  Actions.NAVIGATED_TO,
                  `${url}/${0}/${link}`
                )
              )
            }
          : () => {
              if (
                r?.referralTypeCode === referralClinicTypes.antiDoteReferrals
              ) {
                dispatch(
                  Actions.createAction(Actions.NAV_TO_CLINIC_REFERRAL, r?.type)
                )
              } else {
                dispatch(
                  Actions.createAction(Actions.NAVIGATED_TO, `${url}/${fileId}`) //Antidote lab referral
                )
              }
            },
        actions: r?.isQuestReferral ? getQuestReferralsActions(r) : null,
        locationId: r?.location_id || '',
        isQuestReferral: r?.isQuestReferral,
        orderId: r?.order_id || '',
        isQuest: r?.is_quest,
        isGenericReferral: r?.is_generic_referral,
        file: r?.generic_referral_id || r?.file,
        antidote_clinic: r?.clinic,
        doctor: r?.doctor?.speciality
          ? `Dr. ${r?.doctor?.firstName} ${r?.doctor?.lastName}`
          : `Dr. ${r?.doctor}`
      }
    })
    let sortedData = data.sort((a, b) => {
      return new Date(b?.issueDate) - new Date(a?.issueDate)
    })
    setReferralList(sortedData)
  }, [referrals, questReferrals])

  const footerActions = [
    <Button
      data-name='generic_referral_clicked_web'
      key='1'
      className='dialog-action trackable'
      type='primary'
      onClick={() => {
        dispatch(
          Actions.createAction(Actions.GENERIC_REFERRALS_REQUESTED, {
            orderId: shouldShowReferralDialog.id,
            patientId: selectedMemberId,
            fileId: shouldShowReferralDialog.fileId,
            url
          })
        )
      }}
      disabled={isReferralsLoading}
      loading={isReferralsLoading}
    >
      {$t('questReferrals.getReferral')}
    </Button>,
    <Button
      key='2'
      className='dialog-action'
      type='secondary'
      onClick={() =>
        setShouldShowReferralDialog({
          openModal: false,
          id: null,
          fileId: null
        })
      }
      disabled={isReferralsLoading}
    >
      {$t('questReferrals.cancel')}
    </Button>
  ]

  useEffect(() => {
    if (!isReferralsLoading) {
      setShouldShowReferralDialog({ openModal: false, id: null, fileId: null })
    }
  }, [isReferralsLoading])

  return (
    <div className='my-referrals'>
      <Switch>
        <Route exact path={path}>
          <Page
            displayManageFamily
            title={$t('sideMenu.referrals')}
            className='grey'
          >
            <ListView
              data={referralList}
              dataName='referral_clicked'
              category={$t('sideMenu.referrals').toLowerCase()}
              isLoading={isLoading || isQuestReferralLoading}
            />
          </Page>
        </Route>

        <Route exact path={`${routes.SELECTED_LAB_FACILITY}`}>
          <SelectedLabFacility />
        </Route>

        <Route exact path={`${path}/:fileId`}>
          <FilePreviewPage isDownloadEnable={true} />
        </Route>
      </Switch>
      <Dialog
        title={
          getIsHmoMember(userDetails)
            ? $t('questReferrals.nonQuestReferralTitle')
            : $t('questReferrals.genericReferralTitle')
        }
        isVisible={shouldShowReferralDialog.openModal}
        footerActions={footerActions}
        onCancel={() =>
          setShouldShowReferralDialog({ openModal: false, id: null })
        }
        className='quest-get-referral-modal'
      >
        <div className='existing-user-dialog-content quest-get-referral-modal-desc'>
          {getIsHmoMember(userDetails)
            ? $t('questReferrals.nonQuestReferralDesc')
            : $t('questReferrals.genericReferralDesc')}
        </div>
      </Dialog>
    </div>
  )
}

export default Referrals
